module.exports = __webpack_public_path__ + "static/media/mug-marshmallows.1c1ef160.svg";